import { i18n } from '../i18n';

export const containerHistoriesComment = {
  GATED_IN: {
    name: i18n.t('pages.containerHistories.GATED_IN.name'),
    comment: i18n.t('pages.containerHistories.GATED_IN.comment'),
  },
  GATED_OUT_LOADED: {
    name: i18n.t('pages.containerHistories.GATED_OUT_LOADED.name'),
    comment: i18n.t('pages.containerHistories.GATED_OUT_LOADED.comment'),
  },
  GATED_OUT_LOADING_ALLOWED: {
    name: i18n.t('pages.containerHistories.GATED_OUT_LOADING_ALLOWED.name'),
    comment: i18n.t('pages.containerHistories.GATED_OUT_LOADING_ALLOWED.comment'),
  },
  GATED_OUT: {
    name: i18n.t('pages.containerHistories.GATED_OUT.name'),
    comment: i18n.t('pages.containerHistories.GATED_OUT.comment'),
  },
  UPDATED_HOLD: {
    name: i18n.t('pages.containerHistories.UPDATED_HOLD.name'),
    comment: i18n.t('pages.containerHistories.UPDATED_HOLD.comment'),
  },
  UPDATED: {
    name: i18n.t('pages.containerHistories.UPDATED.name'),
    comment: i18n.t('pages.containerHistories.UPDATED.comment'),
  },
  TRANSFERRED: {
    name: i18n.t('pages.containerHistories.TRANSFERRED.name'),
    comment: i18n.t('pages.containerHistories.TRANSFERRED.comment'),
  },
  TRANSFERRED_FROM: {
    name: i18n.t('pages.containerHistories.TRANSFERRED_FROM.name'),
    comment: i18n.t('pages.containerHistories.TRANSFERRED_FROM.comment'),
  },
  TRANSFERRED_TO: {
    name: i18n.t('pages.containerHistories.TRANSFERRED_TO.name'),
    comment: i18n.t('pages.containerHistories.TRANSFERRED_TO.comment'),
  },
  MARKET_TRANSFERRED: {
    name: i18n.t('pages.containerHistories.MARKET_TRANSFERRED.name'),
    comment: i18n.t('pages.containerHistories.MARKET_TRANSFERRED.comment'),
  },
  MARKET_TRANSFERRED_FROM: {
    name: i18n.t('pages.containerHistories.MARKET_TRANSFERRED_FROM.name'),
    comment: i18n.t('pages.containerHistories.MARKET_TRANSFERRED_FROM.comment'),
  },
  MARKET_TRANSFERRED_TO: {
    name: i18n.t('pages.containerHistories.MARKET_TRANSFERRED_TO.name'),
    comment: i18n.t('pages.containerHistories.MARKET_TRANSFERRED_TO.comment'),
  },
  INVENTORY_CHECKED: {
    name: i18n.t('pages.containerHistories.INVENTORY_CHECKED.name'),
    comment: i18n.t('pages.containerHistories.INVENTORY_CHECKED.comment'),
  },
  SALE_CREATED: {
    name: i18n.t('pages.containerHistories.SALE_CREATED.name'),
    comment: i18n.t('pages.containerHistories.SALE_CREATED.comment'),
  },
  SALE_DELETED: {
    name: i18n.t('pages.containerHistories.SALE_DELETED.name'),
    comment: i18n.t('pages.containerHistories.SALE_DELETED.comment'),
  },
  CONFIRM_PAYMENT: {
    name: i18n.t('pages.containerHistories.CONFIRM_PAYMENT.name'),
    comment: i18n.t('pages.containerHistories.CONFIRM_PAYMENT.comment'),
  },
  REPAIR_CREATED: {
    name: i18n.t('pages.containerHistories.REPAIR_CREATED.name'),
    comment: i18n.t('pages.containerHistories.REPAIR_CREATED.comment'),
  },
  REPAIR_CANCELLED: {
    name: i18n.t('pages.containerHistories.REPAIR_CANCELLED.name'),
    comment: i18n.t('pages.containerHistories.REPAIR_CANCELLED.comment'),
  },
  REPAIR_COMPLETED: {
    name: i18n.t('pages.containerHistories.REPAIR_COMPLETED.name'),
    comment: i18n.t('pages.containerHistories.REPAIR_COMPLETED.comment'),
  },
};
